module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.9e98f8d0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/_global-styles/fonts/ProximaNova/ProximaNova-Bold.woff
// module id = 807
// module chunks = 9